import * as React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import { Dispatch } from 'redux';
import { Avatar } from '@components/basics/avatar';
interface LabelRowProps {
  title: string;
  type: string;
  streams: string;
  earned: string;
  avatar: string;
  continueToMerch: () => CallHistoryMethodAction;
  className?: string;
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    continueToMerch: () => dispatch(push(`/merch/select-product`)),
  };
};

const LabelRow: React.FC<LabelRowProps> = (props) => {
  const { title, type, streams, earned, avatar } = props;
  return (
    <MotionOpacity className={props.className}>
      <FlexContainer>
        <BorderBottom>
          <Radius>
            <Avatar src={avatar} />
          </Radius>
          <FlexContainer>
            <NameRow>
              <Row>
                <Typography
                  weight="700"
                  color={'#32343C'}
                  type="title"
                  customSize="16px"
                  className=""
                >
                  {title.substring(0, 4)}
                  {title.length > 8 ? '...' : ''}
                </Typography>
              </Row>
              <Row>
                <Typography
                  weight="700"
                  color={'#A1A5B4'}
                  type="title"
                  customSize="12px"
                  className=""
                >
                  {type}
                </Typography>
              </Row>
            </NameRow>
            <Row>
              <Row>
                <Typography
                  weight="700"
                  color={'#32343C'}
                  type="title"
                  customSize="16px"
                  className=""
                >
                  {Math.floor(parseFloat(streams)) || 0}
                </Typography>
              </Row>
              <Row>
                <Typography
                  weight="700"
                  color={'#A1A5B4'}
                  type="title"
                  customSize="12px"
                  className=""
                >
                  Streams
                </Typography>
              </Row>
            </Row>
            <Row>
              <Row>
                <Typography
                  weight="700"
                  color={'#32343C'}
                  type="title"
                  customSize="16px"
                  className=""
                >
                  ${earned || 0}
                </Typography>
              </Row>
              <Row>
                <Typography
                  weight="700"
                  color={'#A1A5B4'}
                  type="title"
                  customSize="12px"
                  className=""
                >
                  Earned
                </Typography>
              </Row>
            </Row>
          </FlexContainer>
        </BorderBottom>
      </FlexContainer>
    </MotionOpacity>
  );
};

export default connect(
  null,
  mapDispatchToProps
)(styled(LabelRow)`
  .loading-animation > div {
    margin: auto;
  }
  border-bottom: 1px soild;
`);

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
  align-items: center;
`;
const BorderBottom = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #dddfe7;
`;

const Row = styled.div``;

const NameRow = styled.div`
  width: 40px;
`;

const Radius = styled.div`
    border-radius : 50%;
    border-top-left-radius:5px;
    border-top-right-radius:5px;
    margin-right: 10px;
}`;
